import React, { useEffect, Fragment, useContext } from 'react';
import { useSelector, connect } from 'react-redux';
import { valueToOption } from 'helpers/objectHelpers';
import Select from 'react-select';
import { getTemplateOptions, setTemplate } from 'actions/objectActions';
import LocaleContext from 'constants/localization';

const TemplateOptions = ({setTemplate}) => {
  const [templates, setTemplates] = React.useState([]);
  const [selectedTemplate, setSelectedTemplate] = React.useState('');

  const folder = useSelector(state => state.object.parentUri);
  const LS = useContext(LocaleContext);
  
  useEffect(() => {
    if (folder) {
      getTemplateOptions(folder)
        .then(templates => {
          setTemplates(templates.map(valueToOption));
        });
    }
  }, [folder]);

  return (
    <Fragment>
      <label>{LS.templates}</label>
      <Select 
        options={templates} 
        value={selectedTemplate} 
        onChange={template => setSelectedTemplate(template)} />
      <button className="action-button" type="button" onClick={() => {
        setTemplate(selectedTemplate.value);
      }}>
        {LS.actions.choose}
      </button>
    </Fragment>
  );
};

export default connect(null, { setTemplate })(TemplateOptions);